import React from 'react';
import { motion } from 'framer-motion';
export function SolutionReveal() {
  return <section className="py-32 px-6 bg-bg-main relative overflow-hidden" data-id="element-200">
      {/* Ambient background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-purple/20 rounded-full blur-[150px] pointer-events-none" data-id="element-201" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-202">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-203">
          <h2 className="text-2xl md:text-3xl font-serif text-text-secondary mb-6" data-id="element-204">
            Entonces, ¿qué sí funciona?
          </h2>

          <p className="text-xl md:text-2xl text-text-primary mb-16 max-w-2xl mx-auto leading-relaxed" data-id="element-205">
            Un sistema que no te pida "ser otra persona". Un sistema que te
            proteja justo en el momento del impulso.
          </p>

          <div className="inline-block mb-6" data-id="element-206">
            <span className="text-brand-gold tracking-widest text-sm uppercase font-semibold" data-id="element-207">
              Presentando
            </span>
          </div>

          <h1 className="text-5xl md:text-8xl font-serif text-transparent bg-clip-text bg-gradient-to-br from-white via-brand-pink to-brand-purple mb-6 pb-2" data-id="element-208">
            Anti-Impulso
          </h1>
          <h2 className="text-3xl md:text-5xl font-serif text-text-primary mb-12" data-id="element-209">
            “Cierra el Mes”
          </h2>

          <div className="bg-bg-secondary/80 backdrop-blur-sm border border-white/10 p-8 md:p-12 rounded-3xl max-w-3xl mx-auto shadow-2xl" data-id="element-210">
            <p className="text-xl md:text-2xl text-text-primary font-medium mb-4" data-id="element-211">
              Un workbook de 30 días para dejar de gastar por ansiedad (sin
              sentirte castigada)
            </p>
            <p className="text-lg text-text-secondary" data-id="element-212">
              Este no es un libro "motivacional". Es un plan de ejecución.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}